<template>
  <div class="width-100 mainBox flex-column justify-content-start align-items-center" style="min-width: 1200px">
    <!--    顶部菜单栏-->
    <tab class="fixed" :selectTab="tabList[tabIndex].tabIndex" style="min-width: 1200px"></tab>

    <img src="@/assets/image/banner1.jpg" width="100%" style="min-width: 1200px" alt="" />
    <div class="main flex-row justify-content-spaceBetween align-items-center margin-ts margin-b border-b">
      <p class="fs-mid grey">当前位置：首页 > 集团概况 > {{ tabList[tabIndex].text }}</p>
    </div>
    <div class="main flex-row justify-content-spaceBetween align-items-star">
      <div class="leftBox flex-column justify-content-start align-items-center">
        <p
          :class="{ tab_avtive: index === tabIndex }"
          @click="select(item.index)"
          v-for="(item, index) in tabList"
          :key="index"
          class="tab flex-row justify-content-center align-items-center pointer"
        >
          {{ item.text }}
        </p>
      </div>
      <div v-if="tabIndex === 0" class="width-80">
        <p class="fs-sBig margin-b fw-mid width-100 textAlign-c">{{ tabList[0].text }}</p>
        <p class="width-100 text-indent fs-big lineHeight2 margin-bs">瑞安市国投集团是由市政府授权，市国资办履行出资人职责的功能类国有企业。</p>
        <p class="width-100 text-indent fs-big lineHeight2 margin-bs">主要职责及业务范围</p>
        <p class="width-100 text-indent fs-big lineHeight2">
          1、承担市政府关于城市开发建设、棚改项目、PPP 项目和重大产业项目等重点工程建设领域的投融资、建设活动。
        </p>
        <p class="width-100 text-indent fs-big lineHeight2">
          2、承担通过控股、参股等多种投资方式参与高新科技产业、文化教育、房地产、基础设施、新农村建设等领域投资任务。
        </p>
        <p class="width-100 text-indent fs-big lineHeight2">3、承担所属（管）企业的管理以及改制遗留问题的处理。</p>
        <p class="width-100 text-indent fs-big lineHeight2">4、承担授权范围内国有资产营运，确保国有资产保值增值。</p>
        <p class="width-100 text-indent fs-big lineHeight2">5、承担市政府投资项目所形成的固定资产接收、维护、营运。</p>
        <p class="width-100 text-indent fs-big lineHeight2">6、负责组织、指导所属（管）企业党的建设、群团建设、精神文明建设、平安建设等。</p>
        <p class="width-100 text-indent fs-big lineHeight2">7、承办市委、市政府，市国资办委托、交办的其他事项。</p>
      </div>
      <!--      <div v-if="tabIndex === 1" class="width-80">-->
      <!--        <p class="fs-sBig margin-b fw-mid width-100 textAlign-c">{{ tabList[1].text }}</p>-->
      <!--        <p class="width-100 text-indent fs-mid lineHeight2 margin-b">资料整理中。。。</p>-->
      <!--      </div>-->
      <div v-if="tabIndex === 1" class="width-80">
        <p class="fs-sBig margin-b fw-mid width-100 textAlign-c">{{ tabList[1].text }}</p>
        <!--        <p class="width-100 text-indent fs-mid lineHeight2 margin-b">-->
        <!--          <el-image :src="imagePrefix + deptStructure" style="width: 100%"></el-image>-->
        <!--        </p>-->
        <p class="width-100 fs-mid lineHeight2 margin-b">
          <vue-okr-tree :data="deptTree" node-key="label" direction="horizontal"></vue-okr-tree>
        </p>
      </div>
      <div v-if="tabIndex === 2" class="width-80">
        <p class="fs-sBig margin-b fw-mid width-100 textAlign-c">{{ tabList[2].text }}</p>
        <p class="width-100 text-indent fs-big lineHeight2 margin-ts">
          <strong>（一）办公室。</strong>
        </p>
        <p class="width-100 text-indent fs-big lineHeight1">
          负责集团公司行政综合事务；负责文秘、会务、档案、制度建设、公务接待、网络建设及后勤保障等；负责重大合同审核、法律咨询事务；负责督办事项、人大议案、政协提案、信访的答复工作等。
        </p>
        <p class="width-100 text-indent fs-big lineHeight2 margin-ts"><strong>（二）财务管理部。</strong></p>
        <p class="width-100 text-indent fs-big lineHeight1">
          负责集团公司财务管理、会计核算；负责财务制度建设、财务预决算管理、资金管理、融资管理、债权债务管理、综合统计、税务、财务信息化管理、会计档案管理；参与投资项目相关工作、项目投资论证、资产重组、改制清算等重大事项；指导所属（管）企业财务管理工作等。
        </p>
        <p class="width-100 text-indent fs-big lineHeight2 margin-ts">
          <strong>（三）人力资源部。</strong>
        </p>
        <p class="width-100 text-indent fs-big lineHeight1">
          负责集团公司组织人事工作；负责人事规划、劳动薪酬、绩效考核、人事档案、技术职称评聘、教育培训等；负责退休干部职工管理服务工作等。
        </p>
        <p class="width-100 text-indent fs-big lineHeight2 margin-ts">
          <strong>（四）监察审计部。</strong>
        </p>
        <p class="width-100 text-indent fs-big lineHeight1">
          负责集团公司监察审计、内审工作；负责财务、经营、行政等内控制度建设及监督；协助集团监事会开展工作；配合上级部门开展纪检、监察、审计等工作；负责所属（管）企业贯彻执行政策法规等及违法违纪追责工作；指导所属（管）企业监事会工作等。
        </p>
        <p class="width-100 text-indent fs-big lineHeight2 margin-ts">
          <strong>（五）企业发展部。</strong>
        </p>
        <p class="width-100 text-indent fs-big lineHeight1">
          负责编制和实施集团公司发展战略和中长期规划；负责对外投资管理及投资管理制度建设；负责新设所属（管）企业的前期组建工作；负责可行性投资项目调研和组织实施；组织所属（管）企业的机制体制改革及相关的企业注销、整合、划转、接收、清算工作；负责所属（管）企业历史遗留问题的处置、信访维稳；负责监督、指导所属（管）企业日常管理；负责所属（管）企业的安全生产等。
        </p>
        <p class="width-100 text-indent fs-big lineHeight2 margin-ts">
          <strong>（六）经营管理部。</strong>
        </p>
        <p class="width-100 text-indent fs-big lineHeight1">
          负责集团公司经营资产的营运、维护、整合、盘活管理；负责市工业国有资产投资经营有限公司项目的投资和营运工作等。
        </p>
        <p class="width-100 text-indent fs-big lineHeight2 margin-ts">
          <strong>（七）项目管理部。</strong>
        </p>
        <p class="width-100 text-indent fs-big lineHeight1">
          负责集团公司直接投资项目和代建项目管理；负责城市开发和基础设施项目的投资规划、建设和营运；负责重点建设项目的协调和统计工作；负责市基础设施建设投资有限公司项目的投资和营运工作等。
        </p>
        <p class="width-100 text-indent fs-big lineHeight2 margin-ts">
          <strong>（八）党群工作部。</strong>
        </p>
        <p class="width-100 text-indent fs-big lineHeight">
          负责集团公司党建工作；负责群团工作；协助党委开展党风廉政、行风建设的宣传、教育、指导工作；指导所属（管）企业的党建工作、行风建设等。
        </p>
      </div>
      <div v-if="tabIndex === 3" class="width-80">
        <p class="fs-sBig margin-b fw-mid width-100 textAlign-c">{{ tabList[3].text }}</p>
        <p class="width-100 fs-mid lineHeight2 margin-b">
          <el-steps :active="999999" direction="vertical">
            <el-step
              v-for="(item, index) in majorNewsList"
              :key="index"
              :title="item.majorNewsDate"
              icon="el-icon-s-help"
              :description="item.majorNews"
            ></el-step>
          </el-steps>
          <!--          <el-image :src="fzlc" style="width: 100%"></el-image>-->
        </p>
      </div>
    </div>
    <backBtn></backBtn>
    <footerBox class="margin-t"></footerBox>
  </div>
</template>
<script>
import tab from '@/components/tab.vue';
import footerBox from '@/components/footer.vue';
import backBtn from '@/components/backBtn.vue';
import profileApi from '@/api/profileApi';
import config from '@/config';
import majorNewsApi from '@/api/majorNewsApi';
import moment from 'moment';
import deptApi from '@/api/deptApi';
import { VueOkrTree } from 'vue-okr-tree/lib/vue-okr-tree.umd';
import 'vue-okr-tree/lib/vue-okr-tree.css';
export default {
  name: 'Group',
  components: {
    tab,
    footerBox,
    backBtn,
    VueOkrTree
  },
  data() {
    return {
      fzlc: require('@/assets/image/fzlc.png'),
      currentPage: 1,
      tabIndex: 0,
      imagePrefix: config.IMAGE_PREFIX,
      deptStructure: null,
      tabList: [
        {
          index: 0,
          text: '集团简介',
          tabIndex: '1-1'
        },
        {
          index: 1,
          text: '组织架构',
          tabIndex: '1-2'
        },
        {
          index: 2,
          text: '部室介绍',
          tabIndex: '1-3'
        },
        {
          index: 3,
          text: '发展历程',
          tabIndex: '1-4'
        }
      ],
      // 大事记列表
      majorNewsList: [],
      // 组织架构树状结构
      deptTree: []
    };
  },
  watch: {
    '$route.query.Id'(newVal) {
      this.tabIndex = parseInt(newVal);
    }
  },
  created() {
    this.tabIndex = parseInt(this.$route.query.Id) || 0;
    profileApi
      .one({ profileCode: 'dept_structure' })
      .then((res) => {
        this.deptStructure = res.data.profileImgs;
      })
      .catch((err) => {
        console.log(err);
      });
    // 加载大事记列表
    majorNewsApi.list({}).then((res) => {
      res.data.forEach((item) => {
        item.majorNewsDate = moment(item.majorNewsDate).format('yyyy年MM月');
      });
      this.majorNewsList = res.data;
    });
    // 加载组织架构列表
    deptApi.okrTree({}).then((res) => {
      this.deptTree = res.data;
    });
  },
  methods: {
    select(e) {
      this.tabIndex = e;
    },
    jumpTo(e, m) {
      this.$router.push({ path: e, params: { Id: m } });
    }
  }
};
</script>

<style lang="less" scoped>
.fixed {
  position: fixed;
  top: 0;
  z-index: 99;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}
.mainBox {
  height: 200px;
  padding-top: 60px;
}
.search {
  border: none !important;
}
.searchBox {
  padding: 4px 10px;
  border-radius: 5px;
}
.tab {
  height: 50px;
  width: 100%;
  border-bottom: 1px solid #eeeeee;
}
.tab_avtive {
  background: rgb(11, 73, 158) !important;
  border-left: 6px solid rgb(204, 58, 58);
  color: white;
  border-bottom: none;
}
.border-b {
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 20px;
}
.box {
  height: 140px;
}
.leftBox {
  width: 17%;
  margin-right: 3%;
}
</style>
<style>
.van-pagination__item--active {
  background-color: rgb(11, 73, 158) !important;
  color: #ffffff !important;
}
.van-pagination__item {
  min-width: 30px;
  height: 30px;
  margin: 0 3px;
  border: 1px solid #eeeeee;
  color: #666666;
}
.el-step__main {
  padding-bottom: 40px;
}
.el-step__title {
  font-weight: bold;
}
.el-step__description {
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 0px;
}
.el-step__title.is-finish,
.el-step__description.is-finish {
  color: #333333;
}
.el-step__icon-inner.el-icon-s-help {
  color: rgb(11, 73, 158);
}
.el-step__line-inner {
  border-color: rgb(11, 73, 158);
}
.el-step__head {
  margin-right: 20px;
}
</style>
